import PropTypes from "prop-types";
import React from "react";
import Row from "./Row";

export default class Body extends React.Component {

    render() {
        const {
            records = [],
            columns,
            selected,
            onDownloadClick,
            onRecordSelection,
            renderUnsafe,
        } = this.props;

        let items;

        if (records.length > 0) {
            items = records.map((record) => {
                const isActive = selected ? selected.id === record.id : false;
                return (
                    <Row
                        key={record.id}
                        ITid={record.id}
                        onRecordSelection={onRecordSelection}
                        onDownloadClick={onDownloadClick}
                        record={record}
                        columns={columns}
                        renderUnsafe={renderUnsafe}
                        isActive={isActive}
                    />
                );
            });
        } else {
            items = (
                <tr id="nosearchresults_row" className="disabled">
                    <td id="nosearchresults_cell" colSpan={columns.length}>
                        No Results Found
                    </td>
                </tr>
            );
        }

        return <React.Fragment>{items}</React.Fragment>;
    }
}

Body.propTypes = {
    records: PropTypes.array,
    columns: PropTypes.array.isRequired,
    selected: PropTypes.object,
    onRecordSelection: PropTypes.func.isRequired,
    onDownloadClick: PropTypes.func,
    renderUnsafe: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/lib/body/Body.js